'use client'
"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/dialog.web.tsx
var dialog_web_exports = {};
__export(dialog_web_exports, {
  Close: () => Close2,
  Content: () => Content2,
  Description: () => Description2,
  Overlay: () => Overlay2,
  Portal: () => Portal2,
  Root: () => Root2,
  Title: () => Title2,
  Trigger: () => Trigger2,
  useRootContext: () => useRootContext
});
module.exports = __toCommonJS(dialog_web_exports);
var Dialog = __toESM(require("@radix-ui/react-dialog"));
var import_hooks = require("@rn-primitives/hooks");
var Slot = __toESM(require("@rn-primitives/slot"));
var React = __toESM(require("react"));
var import_react_native = require("react-native");
var DialogContext = React.createContext(null);
var Root2 = React.forwardRef(
  ({ asChild, open: openProp, defaultOpen, onOpenChange: onOpenChangeProp, ...viewProps }, ref) => {
    const [open = false, onOpenChange] = (0, import_hooks.useControllableState)({
      prop: openProp,
      defaultProp: defaultOpen,
      onChange: onOpenChangeProp
    });
    const Component = asChild ? Slot.View : import_react_native.View;
    return <DialogContext.Provider value={{ open, onOpenChange }}><Dialog.Root open={open} defaultOpen={defaultOpen} onOpenChange={onOpenChange}><Component ref={ref} {...viewProps} /></Dialog.Root></DialogContext.Provider>;
  }
);
Root2.displayName = "RootWebDialog";
function useRootContext() {
  const context = React.useContext(DialogContext);
  if (!context) {
    throw new Error("Dialog compound components cannot be rendered outside the Dialog component");
  }
  return context;
}
var Trigger2 = React.forwardRef(
  ({ asChild, onPress: onPressProp, role: _role, disabled, ...props }, ref) => {
    const augmentedRef = (0, import_hooks.useAugmentedRef)({ ref });
    const { onOpenChange, open } = useRootContext();
    function onPress(ev) {
      if (onPressProp) {
        onPressProp(ev);
      }
      onOpenChange(!open);
    }
    (0, import_hooks.useIsomorphicLayoutEffect)(() => {
      if (augmentedRef.current) {
        const augRef = augmentedRef.current;
        augRef.dataset.state = open ? "open" : "closed";
        augRef.type = "button";
      }
    }, [open]);
    const Component = asChild ? Slot.Pressable : import_react_native.Pressable;
    return <Dialog.Trigger disabled={disabled ?? void 0} asChild><Component
      ref={augmentedRef}
      onPress={onPress}
      role='button'
      disabled={disabled}
      {...props}
    /></Dialog.Trigger>;
  }
);
Trigger2.displayName = "TriggerWebDialog";
function Portal2({ forceMount, container, children }) {
  return <Dialog.Portal forceMount={forceMount} children={children} container={container} />;
}
var Overlay2 = React.forwardRef(
  ({ asChild, forceMount, ...props }, ref) => {
    const Component = asChild ? Slot.Pressable : import_react_native.Pressable;
    return <Dialog.Overlay forceMount={forceMount}><Component ref={ref} {...props} /></Dialog.Overlay>;
  }
);
Overlay2.displayName = "OverlayWebDialog";
var Content2 = React.forwardRef(
  ({
    asChild,
    forceMount,
    onOpenAutoFocus,
    onCloseAutoFocus,
    onEscapeKeyDown,
    onInteractOutside,
    onPointerDownOutside,
    ...props
  }, ref) => {
    const Component = asChild ? Slot.View : import_react_native.View;
    return <Dialog.Content
      onOpenAutoFocus={onOpenAutoFocus}
      onCloseAutoFocus={onCloseAutoFocus}
      onEscapeKeyDown={onEscapeKeyDown}
      onInteractOutside={onInteractOutside}
      onPointerDownOutside={onPointerDownOutside}
      forceMount={forceMount}
    ><Component ref={ref} {...props} /></Dialog.Content>;
  }
);
Content2.displayName = "ContentWebDialog";
var Close2 = React.forwardRef(
  ({ asChild, onPress: onPressProp, disabled, ...props }, ref) => {
    const augmentedRef = (0, import_hooks.useAugmentedRef)({ ref });
    const { onOpenChange, open } = useRootContext();
    function onPress(ev) {
      if (onPressProp) {
        onPressProp(ev);
      }
      onOpenChange(!open);
    }
    (0, import_hooks.useIsomorphicLayoutEffect)(() => {
      if (augmentedRef.current) {
        const augRef = augmentedRef.current;
        augRef.type = "button";
      }
    }, []);
    const Component = asChild ? Slot.Pressable : import_react_native.Pressable;
    return <><Dialog.Close disabled={disabled ?? void 0} asChild><Component
      ref={augmentedRef}
      onPress={onPress}
      role='button'
      disabled={disabled}
      {...props}
    /></Dialog.Close></>;
  }
);
Close2.displayName = "CloseWebDialog";
var Title2 = React.forwardRef(({ asChild, ...props }, ref) => {
  const Component = asChild ? Slot.Text : import_react_native.Text;
  return <Dialog.Title asChild><Component ref={ref} {...props} /></Dialog.Title>;
});
Title2.displayName = "TitleWebDialog";
var Description2 = React.forwardRef(
  ({ asChild, ...props }, ref) => {
    const Component = asChild ? Slot.Text : import_react_native.Text;
    return <Dialog.Description asChild><Component ref={ref} {...props} /></Dialog.Description>;
  }
);
Description2.displayName = "DescriptionWebDialog";
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  Close,
  Content,
  Description,
  Overlay,
  Portal,
  Root,
  Title,
  Trigger,
  useRootContext
});
